import { createStructuredSelector } from 'reselect';

import {
  stepIdSelector,
  completeSTEP1Selector,
  completeSTEPAPPLICANTTYPESelector,
  completeSTEPAPPLICANTSelector,
  completeSTEP2Selector,
  completeSTEP3Selector,
  completeSTEP4Selector,
  showSTEP3Selector,
  showSTEP4Selector,
  showSTEP5Selector
} from '../../store/step/selectors';

import { applicantTypeSelector } from '../../store/applicant/selectors';

import { mainDataValuesSelector } from '../../store/mainData/selectors';

const formStructuredSelector = createStructuredSelector({
  stepId: stepIdSelector,
  completeSTEP1: completeSTEP1Selector,
  completeSTEPAPPLICANTTYPE: completeSTEPAPPLICANTTYPESelector,
  completeSTEPAPPLICANT: completeSTEPAPPLICANTSelector,
  completeSTEP2: completeSTEP2Selector,
  completeSTEP3: completeSTEP3Selector,
  completeSTEP4: completeSTEP4Selector,
  showSTEP3: showSTEP3Selector,
  showSTEP4: showSTEP4Selector,
  showSTEP5: showSTEP5Selector,
  applicantType: applicantTypeSelector,
  mainData: mainDataValuesSelector
});

export default formStructuredSelector;
